@if (isAuthRoute()) {
  <div class="h-full w-full">
    <router-outlet></router-outlet>
  </div>
} @else {
  <div class="fullscreen-bg h-full w-full">
    <stop-page-header
      [username]="username()"
      [initials]="initials()"
      [userMenuOpen]="userMenuOpen()"
      [userMenuAriaLabel]="'pageHeader.ariaUserMenu' | transloco"
      [closeMenuAriaLabel]="'pageHeader.ariaCloseUserMenu' | transloco"
      [logoutLabel]="'pageHeader.logout' | transloco"
      (toggleMenu)="toggleUserMenu()"
      (closeMenu)="closeUserMenu()"
    />
    <router-outlet></router-outlet>
  </div>
}
